import Currency from './Currency';

export default new Currency();